import aggiungi from  './aggiungi'
import uploadModulistica from  './upload-modulistica'
import reportPdp from  './report-pdp'

export default [
  // always
  {
    'key': 'agenti-button-aggiungi',
    'label': 'AGGIUNGI AGENTE',
    'classCss': 'p-button-secondary',
     icon: " pi pi-plus",
    'type': 'operation',
    'method': aggiungi,
    'display': 'always'
  },
  {
    'key': 'agenti-button-aggiungi-modulistica',
    'label': 'AGGIUNGI MODULISTICA',
    'classCss': 'p-button-secondary',
     icon: " pi pi-plus",
    'type': 'operation',
    'method': uploadModulistica,
    'display': 'always'
  },
  {
    'key': 'agenti-button-report-pdp',
    'label': 'REPORT POD|PDR',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-table',
    'type': 'operation',
    'method': reportPdp,
    'display': 'always'
  },
  // on-data-filtered
  
]
